import { Grid, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  rsTableEmptyRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
  },
}));

const TableEmptyState = (props) => {
  const { text = "No Data Found!" } = props;
  const classes = useStyle();

  return (
    <>
      <TableRow>
        <TableCell noBorder colSpan={100}>
          <Grid className={classes.rsTableEmptyRoot}>{text}</Grid>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableEmptyState;
